module.exports = __webpack_public_path__ + "img/content2.2b9cdce0.png";